module.exports = __webpack_public_path__ + "img/Drug_Farm_old_logo.b391e481.svg";